import { render, staticRenderFns } from "./ClaimsPrivate.vue?vue&type=template&id=2191aa3a"
import script from "./ClaimsPrivate.vue?vue&type=script&lang=js"
export * from "./ClaimsPrivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports